import { RootState } from "App/Store";

import * as constants from "Common/EVaultAppConstants";

import { ILoanTab } from "Features/Tabs/Tabs";

export function getAllLoanTabs(state: RootState): ILoanTab {
  return state.tabs[constants.ALL_LOANS];
}
